import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AuditoriaService } from 'src/app/services/http/auditoria.service';
import { AuthGuardService } from 'src/app/services/auth-guard-service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-form-nova-associacao',
  templateUrl: './form-nova-associacao.component.html',
  styleUrls: ['./form-nova-associacao.component.scss']
})
export class FormNovaAssociacaoComponent implements OnInit {

  @Output() formulario = new EventEmitter();

  associacaoAuditoria;

  tableLoading: boolean = false;

  params = {
    filter: {
    },
    sorting: {
      nomeFantasia: 'asc',
      nome: 'asc'
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }

  form = new FormGroup({
    cliente: new FormControl('', Validators.required),
    auditor: new FormControl('', Validators.required)
  });

  listaUnidadesClientes = [{ nomeFantasia: '', id: '' }];
  listaUnidadesAuditora = [{ nome: '', id: '' }];

  id = null;
  cliente = null;
  tipoUnidade: any;

  constructor(private laudoUnionService: LaudoUnionService, private auditoriaService: AuditoriaService, private router: Router, private route: ActivatedRoute, private authGuard: AuthGuardService, private msgService: ModalMsgService) {
    this.id = this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.tipoUnidade = this.authGuard.user.unidade.tipoUnidade.nome;
    // Insere o usuário logado na lista de auditores para criar uma nova associação ...
    let auditorLogado = {
      id: this.authGuard.user.id,
      nome: this.authGuard.user.nome
    }
    this.auditoriaService.getUnidadesClientesAssociados().then(r => {
      this.listaUnidadesClientes = this.listaUnidadesClientes.concat(r);
      this.editForm();
    });
    this.auditoriaService.getUsuariosAuditoria().then(r => { 
      this.listaUnidadesAuditora = this.listaUnidadesAuditora.concat(r).concat(auditorLogado);
    });
  }

  editForm() {
    if (this.id) {
      this.cliente = this.listaUnidadesClientes.find(v => v.id == this.id);
      let cliente = this.cliente;
      this.form.controls.cliente.patchValue(this.cliente);
    }
  }

  sendForm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    let unidadeCliente = this.form.controls.cliente.value;
    let dados = {
      idAuditor: parseInt(this.form.controls.auditor.value),
      idUnidade: parseInt(unidadeCliente.id),
      idPai: parseInt(unidadeCliente.idPai),
      avulso: unidadeCliente.avulso
    }
    this.auditoriaService.getSalvarAssociacaoAuditoria(dados).then(r => {
      if( r.status ){
        this.msgService.openDialog(r.msg);
      }else{
        this.msgService.openDialog('Erro ao efetuar operação', r.msg, 'danger');
      }
      this.formulario.emit();
    });
  }

}
